function playPauseVideo() {
  const videos = document.querySelectorAll("video.video-observer"); // Select ALL the Videos
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (!entry.isIntersecting) {
        video.pause(); // Pause the TARGET video
      } else {
        if (!video.src && video.dataset.src) {
          video.src = video.dataset.src; // Download the video only once it's needed
        }
        video.play(); // Play the TARGET video
      }
    });
  }, { rootMargin: "75px 0px" });
  for (const video of videos) observer.observe(video); // Observe EACH video
  const onVisibilityChange = () => {
    if (document.hidden) {
      for (const video of videos) video.pause(); // Pause EACH video
    } else {
      for (const video of videos) video.play(); // Play EACH video
    }
  };
  document.addEventListener("visibilitychange", onVisibilityChange);
}

playPauseVideo();

const watchVideoButton = document.querySelector(".watch-video-button");

if (watchVideoButton) {
  watchVideoButton.onclick = () => {
    const videoLink = watchVideoButton.closest("[data-video-link]").dataset.videoLink;

    basicLightbox.create(`
          <div>  <iframe
            class="max-w-[90%] max-h-[45vw] m-auto custom-youtube-iframe"
            width="1280"
            height="720"
            src="${videoLink}"
            title="How To Use Chebe Hair Butter"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <button class="steps-video-close-btn absolute right-[0.5em] top-[0.5em] md:right-[-3em] md:top-[-3em] bg-gray-200 p-3 rounded-full">
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1.68182 10.3181L11.1818 0.818115" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.1818 10.3181L1.68182 0.818115" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
    `, {
      onShow: (instance) => {
        instance.element().querySelector(".steps-video-close-btn").onclick = instance.close;
      }
    }).show();
  };
}
